module.exports = __webpack_public_path__ + "img/bars.d288f2e7.svg";